module.exports = __webpack_public_path__ + "static/media/logo1.0e86aa8d.jpeg";